import { render, staticRenderFns } from "./FAQ-custom.vue?vue&type=template&id=5f6466f7&"
import script from "./FAQ-custom.vue?vue&type=script&lang=js&"
export * from "./FAQ-custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports